import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import { pickLang, t } from "@/i18n/booking";

// Condiciones vigentes del alquiler, para leerlas antes de aceptar la reserva.
// El HTML llega ya escapado del servidor (contract_terms.public_terms).
export default function PublicTerms() {
  const location = useLocation();
  const lang = pickLang(location.search);
  const [terms, setTerms] = useState(null);
  useEffect(() => {
    api.get("/public/terms").then(({ data }) => setTerms(data)).catch(() => setTerms({ clauses: [] }));
  }, []);
  return (
    <PublicLayout lang={lang}>
      {() => (
        <article className="max-w-3xl bg-white border border-[#DCD8D0] rounded-xl p-8 space-y-4" data-testid="public-terms">
          <h1 className="font-display text-3xl font-bold text-[#1A1A1A]">{t(lang, "terms_title")}</h1>
          {lang !== "es" && <p className="text-sm text-[#5C5C5C]">{t(lang, "terms_spanish_only")}</p>}
          {!terms && <p className="text-[#5C5C5C]">…</p>}
          {terms?.clauses.map((c) => (
            <section key={c.title}>
              <h2 className="font-display text-lg font-semibold text-[#1A1A1A] mt-4">{c.title}</h2>
              <div className="text-sm leading-relaxed text-[#3A3A3A] space-y-2" dangerouslySetInnerHTML={{ __html: c.html }} />
            </section>
          ))}
        </article>
      )}
    </PublicLayout>
  );
}
